<template>
    <div>
        <div id="svgperf" style="position: relative; z-index:1">
            <svg-graph
                width="100%"
                height="100%"
                v-if="schoolID"
                :school="school"
                :logoImage="logoImage"
                :reportData="reportData"
                :topClasses="topClasses"
                :totalScans="totalScans"
                :topTeachers="topTeachers"
                :topStudents="topStudents"
                :reportMonth="reportMonth"
                :totalPoints="totalPoints"
                :behaviours="behaviours"
            />
        </div>  
    </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import {svg2pdf} from "svg2pdf.js";
import { saveAs } from 'file-saver'
import {jsPDF} from "jspdf";
import SvgGraph from "./SvgGraph";
import imageEncode from "@/services/imageEncode";

export default {
    components: {
        SvgGraph,
    },
    data() {
        return {
            logoImage: "",
            loaded: false,
            list: [],
            downloadList: {},
            queue: [],
        };
    },
    computed: {
        behaviours(){
            return this.$store.getters.behaviours;
        },
        schoolID() {
            return this.$route.params.schoolID;
        },
        topClasses() {
            return this.$store.getters.topClasses;
        },
        topTeachers() {
            return this.$store.getters.topTeachers;
        },
        topStudents() {
            return this.$store.getters.topStudents;
        },
        reportMonth() {
            return this.$store.state.reportMonth.toUpperCase();
        },
        reportData() {
            return {
                ...this.$route.params,
                label: "April 2021"
            };
        },
        school() {
            return this.$store.state.schoolPerformance.school || {};
        },
        totalPoints() {
            return this.$store.getters.totalPoints;
        },
        totalScans() {
            return this.$store.getters.totalScans;
        },
    },
    watch: {
        reportData() {
            this.loadData();
        },
    },
    mounted() {
        this.loadList();
        this.loadData();
    },
    methods: {
        downloadNow() {
            this.startDownload();
        },
        startDownload() {
            const svgData = this.$refs.perf.$el
            
            var pdf = new jsPDF("l", "mm", [595, 842]);
            svg2pdf(svgData, pdf, {
                scale: 1,
            }).then(pdf => {
                pdf.save(`${this.schoolID}-${this.school.name}.pdf`);
            })
        },
        loadList() {
            axios.get("http://localhost:3000").then((res) => {
                this.list = res.data;
            });
        },
        loadData() {
            if (!this.reportData.schoolID) {
                return;
            }

            this.loaded = false;
            this.loadLogo().then(() => {
                // this.loaded = true
            });
            this.$store.dispatch("load.annual", this.reportData).then(() => {
                this.loaded = true;
            });
        },
        loadLogo() {
            return axios
                .get(
                    `https://api.studentqr.com/public/logo?schoolID=${this.reportData.schoolID}`,
                    {
                        responseType: "arraybuffer",
                    }
                )
                .then((res) => {
                    this.logoImage = imageEncode(res.data);
                });
        },
    },
    filters: {
        toLocale(v) {
            if (!parseInt(v)) {
                return v;
            }

            return parseInt(v).toLocaleString();
        },
    },
};
</script>

<style lang="scss">
#svgperf {
    width: 100vw;
    height: 98vh;
    background: #fff;
}
</style>
